import request from '@/utils/request'

// 游戏列表接口（分类）
export function gameListApi(data) {
  return request.get('/game/list', { params: data })
}

// 首页游戏接口
export function gameIndexApi(data) {
  return request.get('/game/index', { params: data })
}

// 轮播图接口
export function bannerApi(data) {
  return request.get('/banner/list', { params: data })
}

// 滚动公告接口
export function noticeRollApi(data) {
  return request.get('/notice/list', { params: data })
}

// 游戏分类接口
export function cateListApi(data) {
  return request.get('/api/index/cate_list', { params: data })
}

// 暴彩金接口
export function jackpotApi() {
  return request.get('/jackpot')
}

// 首页 brand_id数组查询的游戏列表
export function gameHallListApi(params) {
  return request.get('/game/hallList', { params })
}

// 落地页
export function landApi(params) {
  return request.get('/v1/land', { params })
}
